<div
  *ngIf="isLoading"
  
>
  <app-busy [message]="message"></app-busy>
</div>

<div class="page_header">
  <h1 class="heading">Gazettes</h1>
</div>

<button class="btn btn-sm btn-gazette" data-toggle="modal" data-target="#saveGazettePopUp">+ Add Gazette</button>
<table class="table custom_table" cellspacing="0" width="100%">
    <thead>
        <tr>
            <th>Gazette Number</th>
            <th>Description</th>
            <th>Sent Date</th>
            <th>Gazette Date</th>
            <th>Status</th>
            <th>No. of Application</th>
            <th>Actions</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let g of list">
            <td>{{g.id}}</td>
            <td>{{g.description}}</td>
            <td>{{g.date_sent  | date: "dd/MM/yyyy"}}</td>
            <td>{{g.date_scheduled  | date: "dd/MM/yyyy"}}</td>
            <td *ngIf="g.reg_event_status == 1">Saved</td>
            <td *ngIf="g.reg_event_status == 11">Ready for Approval</td>
            <td *ngIf="g.reg_event_status == 13">Returned for editing</td>
            <td *ngIf="g.reg_event_status == 15">Submitted for Approved</td>
            <td *ngIf="g.reg_event_status == 21">Approved</td>
            <td *ngIf="g.reg_event_status == 23">Submitted for Quote</td>
            <td *ngIf="g.reg_event_status == 31">Quote Accepted</td>
            <td *ngIf="g.reg_event_status == 41">Gazetted</td>
            <td>{{g.regulatory_application.length}}</td>
            <td class="text-center">
                <span
                    id="edit"
                    title="Edit Account"
                    style="margin-right: 10px"
                  (click)="edit(g.id)">
                <img
                    src="../../../assets/newimg/border-color-13@2x.png"
                    title="Edit Gazette"
                    style="cursor: pointer; width: 18px"
                  />
                </span>
                  <img
                    src="../../../assets/newimg/delete-30@2x.png"
                    title="Delete Gazette"
                    style="cursor: pointer; width: 18px"
                    (click)="delete(g.id)"
                  />
            </td>
        </tr>
    </tbody>
</table>



<!-- Add Popup -->
  <!-- Modal -->
  <div class="modal fade" id="saveGazettePopUp" tabindex="-1" role="dialog" aria-labelledby="saveGazettePopUpLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeGazettePopUp">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="regulatory_eventForm">
            <div class="row" style="display: none;">
              <div class="col-md-4">
                 Gazette Number
              </div>
              <div class="col-md-4">
                 1241541
              </div>
              
          </div>
          <div class="row" style="display: none;">
              <div class="col-md-4">
                 Status
              </div>
              <div class="col-md-4">
                  <span *ngIf="isSaved">Saved</span>
                  <input type="hidden" formControlName="reg_event_status">
              </div>
              
          </div>
          <div class="row">
              <div class="col-md-4">
                 Description
              </div>
              <div class="col-md-4">
                  <textarea style="width: fit-content;" class="form-control" formControlName="description" required ></textarea>
              </div>
              
          </div>
          <div class="row">
              <div class="col-md-4">
                 Date to be published
              </div>
              <div class="col-md-4">
                  <input type="date" class="form-control" style="width: fit-content;" formControlName="date_scheduled" required >
              </div>
              
          </div>
          </form>
           
        </div>
        <div class="modal-footer">
               <button class="btn btn-sm g-cancel" data-dismiss="modal">
                Cancel
               </button>
               <button class="btn btn-sm g-next" [ngClass]="{'g-saved': this.regulatory_eventForm.invalid === false}" (click)="save()" [disabled]="regulatory_eventForm.invalid">
                Save & Next
               </button>
        </div>
      </div>
    </div>
  </div>

